import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../infra/hooks";

interface IProps {
  setEmpDetails: (data: any) => void;
}
const DTOPaySlipModal: React.FC<IProps> = ({ setEmpDetails }) => {
  const employee = useAppSelector((state) => state.authSlice);
  const personalInfo = useAppSelector((state) => state.personalInfoSlice);
  const currency = useAppSelector((state) => state.authSlice.currency);

  useEffect(() => {
    setEmpDetails({
      empName: personalInfo.firstName + " " + personalInfo.lastName,
      empDesig: employee.designaion,
      empId: employee.emp_id,
      staff_id: employee.staff_id,
      currency: currency,
    });
  }, []);
  return <></>;
};
export default DTOPaySlipModal;
